var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-auth-page"},[_c('van-loading',{attrs:{"type":"spinner","size":"40px","vertical":""}},[_vm._v(" 微信登录中... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }